import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useDeleteAutomationTemplateMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IAutomationTemplateReference) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id }: { id: string }) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplateReference>(
				`automationTemplate/${id}`,
				'DELETE',
				null
			);
		},
		onError,
		onSuccess,
	});
};
